import React, { Component } from 'react';
import Slider from 'react-slick';
import SlickPrevArrow from './SlickPrevArrow';
import SlickNextArrow from './SlickNextArrow';
import education from './../assets/img/education.svg';
import workforce from './../assets/img/workforce.svg';
import healthcare from './../assets/img/healthcare.svg';
import housing from './../assets/img/housing.svg';

class Slick extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0px',
      autoplay: true,
      autoplaySpeed: 8000,
      prevArrow: <SlickPrevArrow />,
      nextArrow: <SlickNextArrow />
    };
    return (
      <div className='slick-container'>
          <Slider {...settings} className='slick'>
              <div className='slick-slide-wrapper'>
                  <div className='slick-slide'>
                      <p className='description'>In the workplace, <span className='highlight-2'>85% of current jobs</span> and <span className='highlight-2'>90% of new jobs</span> require some or more college or post-secondary education.<sup><a href='http://bit.ly/2rsMD2p' target='_blank'>2</a></sup></p>
                      <img className='graphic' src={workforce} />
                  </div>
              </div>

              <div className='slick-slide-wrapper'>
                  <div className='slick-slide'>
                      <p className='description'>Trust for America’s Health estimates that an investment of $10 per person per year in community-based programs tackling physical inactivity, poor nutrition, and smoking could yield more than <span className='highlight-3'>$16 billion in medical cost savings</span> annually within 5 years.<sup><a href='http://bit.ly/2G7zn6H' target='_blank'>3</a></sup></p>
                      <img className='graphic' src={healthcare} />
                  </div>
              </div>

              <div className='slick-slide-wrapper'>
                  <div className='slick-slide'>
                      <p className='description'> On average, there are only <span className='highlight-4'>28 adequate and a<span className='affordable'>ff</span>ordable units available</span> for every 100 renter households with incomes at or below 30 percent of the area median income.<sup><a href='http://urbn.is/2F0o6DJ' target='_blank'>4</a></sup></p>
                      <img className='graphic' src={housing} />
                  </div>
              </div>

              <div className='slick-slide-wrapper'>
                  <div className='slick-slide'>
                      <p className='description'>High schools are not preparing students with the skills and knowledge necessary to excel after graduation. Only <span className='highlight-3'>1 in 4 high school students</span> graduate college-ready in the 4 core subjects of English, Reading, Math and Science.<sup><a href='http://bit.ly/2pmyDRj' target='_blank'>1</a></sup></p>
                      <img className='graphic' src={education} />
                  </div>
              </div>
          </Slider>
      </div>
    );
  }
}

export default Slick;



// WEBPACK FOOTER //
// ./src/components/slick.js